var _style, _g, _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestFinish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{opacity:0.2;}\n\t.st2{fill:#CCCCCC;}\n\t.st3{fill:#F79422;}\n\t.st4{opacity:0.1;}\n\t.st5{fill:none;}\n\t.st6{fill:#B3B3B3;}\n\t.st7{fill:#8F4D38;}\n\t.st8{fill:#EF5350;}\n\t.st9{fill:#C02E1D;}\n\t.st10{clip-path:url(#SVGID_2_);fill:#E4C05C;}\n\t.st11{fill:#DDA86F;}\n\t.st12{fill:#BC9C4D;}\n\t.st13{clip-path:url(#SVGID_4_);fill:#E4C05C;}\n\t.st14{fill:#8CC63F;}\n\t.st15{fill:#7AC943;}\n\t.st16{opacity:0.1;fill:#39B54A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.3,
    y: 4,
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    className: "st0",
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 4,
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.7,
    y: 4,
    className: "st0",
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 4,
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.3,
    y: 4,
    className: "st0",
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7.5,
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 7.5,
    className: "st0",
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.7,
    y: 7.5,
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3,
    y: 7.5,
    className: "st0",
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.3,
    y: 7.5,
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 7.5,
    className: "st0",
    width: 3.3,
    height: 3.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 12.3,
    y: 11,
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 11,
    className: "st0",
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 11,
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.7,
    y: 11,
    className: "st0",
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 11,
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.3,
    y: 11,
    className: "st0",
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14.5,
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 14.5,
    className: "st0",
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.7,
    y: 14.5,
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3,
    y: 14.5,
    className: "st0",
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.3,
    y: 14.5,
    width: 3.3,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 14.5,
    className: "st0",
    width: 3.3,
    height: 3.5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    className: "st1",
    width: 20,
    height: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.3,32H4.7c-1,0-1.7-0.8-1.7-1.7V1.7C3,0.8,3.8,0,4.7,0h0.5C6.2,0,7,0.8,7,1.7v28.5C7,31.2,6.2,32,5.3,32z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 2,
    width: 3.2,
    height: 3.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 2,
    className: "st0",
    width: 3.2,
    height: 3.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 2,
    width: 3.2,
    height: 3.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8,
    y: 2,
    className: "st0",
    width: 3.2,
    height: 3.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3,
    y: 2,
    width: 3.2,
    height: 3.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2,
    y: 2,
    className: "st0",
    width: 3.2,
    height: 3.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.5,
    width: 3.2,
    height: 3.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3,
    y: 5.5,
    className: "st0",
    width: 3.2,
    height: 3.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8,
    y: 5.5,
    width: 3.2,
    height: 3.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 5.5,
    className: "st0",
    width: 3.2,
    height: 3.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2,
    y: 5.5,
    width: 3.2,
    height: 3.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 5.5,
    className: "st0",
    width: 3.2,
    height: 3.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 9,
    width: 3.2,
    height: 3.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 9,
    className: "st0",
    width: 3.2,
    height: 3.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 9,
    width: 3.2,
    height: 3.5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8,
    y: 9,
    className: "st0",
    width: 3.2,
    height: 3.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3,
    y: 9,
    width: 3.2,
    height: 3.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2,
    y: 9,
    className: "st0",
    width: 3.2,
    height: 3.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 12.5,
    width: 3.2,
    height: 3.5
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3,
    y: 12.5,
    className: "st0",
    width: 3.2,
    height: 3.5
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8,
    y: 12.5,
    width: 3.2,
    height: 3.5
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 12.5,
    className: "st0",
    width: 3.2,
    height: 3.5
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 2.5,
    height: 3.5
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5.5,
    className: "st0",
    width: 2.5,
    height: 3.5
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 9,
    width: 2.5,
    height: 3.5
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12.5,
    className: "st0",
    width: 2.5,
    height: 3.5
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 10 18)",
    className: "st4",
    width: 4,
    height: 14
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2,
    y: 12.5,
    width: 3.2,
    height: 3.5
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12.5,
    className: "st0",
    width: 3.2,
    height: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestFinish);
export default __webpack_public_path__ + "static/media/request_finish.a981ab7c11ea644d636836e79227989b.svg";
export { ForwardRef as ReactComponent };